import { render, staticRenderFns } from "./handle-remark.vue?vue&type=template&id=c93da8a0&scoped=true"
import script from "./handle-remark.vue?vue&type=script&lang=js"
export * from "./handle-remark.vue?vue&type=script&lang=js"
import style0 from "./handle-remark.vue?vue&type=style&index=0&id=c93da8a0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93da8a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c93da8a0')) {
      api.createRecord('c93da8a0', component.options)
    } else {
      api.reload('c93da8a0', component.options)
    }
    module.hot.accept("./handle-remark.vue?vue&type=template&id=c93da8a0&scoped=true", function () {
      api.rerender('c93da8a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/senate/detail-pane/components/handle-remark.vue"
export default component.exports